import { VIDEO_SIZE_LIMIT_BYTES, IMAGE_SIZE_LIMIT_BYTES, TOPIC_VIDEO_SIZE_LIMIT_BYTES } from "./constants";
import { faUsers, faAtom, faUserAlt, faBuilding } from '@fortawesome/free-solid-svg-icons'

// This file is used to hold contents of text such as page descriptions and titles
export const ASSIGNMENT_STEPS = [
  {
    step: 1,
    content: 'Enter email or emails of clients. You may also select presaved groups of emails.',
    subcontent: 'Note: Email of client must match the email your client uses to log into Fitbanx'
  }, {
    step: 2,
    content: 'Select Workouts or Programs'
  }, {
    step: 3,
    content: 'Click Assign Now Button'
  }
]

export const CONSTANTS_STATIC = {
  DASHBOARD: '/dashboard',
  CHART_LINE_ICON: 'chart-line',
  BUILD_WORKOUT: '/build/workout',
  FOLDER_ICON: 'folder-open',
  PUSH_ICON: 'edit',
  LAYER_ICON: 'layer-group',
  CLIPBOARD_ICON: 'clipboard-list',
  CHAT_ICON: 'comment',
  LIB_WORKOUT: '/library/workouts'
}

export const ARCHIVE_MENU = [{
  _id: '1',
  name: 'Archive'
}];

export const ASSIGN_PARTNERS_INSTRUCTIONS = `Select workouts from list. Workouts will automatically be sorted from newest to oldest. You can only add 9 workouts at a time. Your oldest workout will expire when you enter the 10th workout. Keep your content fresh and creative.`;
export const ASSIGN_MARKETPLACE_MESSAGE = `Assign workouts and/or programs to the Fitbanx digital marketplace for the world to view and/or purchase`;
export const EXERCISE_VIDEO_INSTRUCTIONS = `- Always record video with phone in horizontal position\n Start the video at the beginning of the exercise \n- Try to get 4 good reps\n- Stop the video at the beginning of the 5th rep (same point of the exercise of where you started)\n- Keep the angle of the camera in same position if possible`

export const WORKOUT_LIBRARY_MESSAGE = `Make edits or changes to workouts you have already built.`;
export const PROGRAM_LIBRARY_MESSAGE = `Make edits or changes to programs you have already built.`;
export const BLOCK_LIBRARY_MESSAGE = `Make edits or changes to blocks you have already built.`;
export const EXERCISE_LIBRARY_MESSAGE = `Make edits or changes to exercises you have already added to your library.`;
export const INSTRUCTION_LIBRARY_MESSAGE = `Make edits or changes to youtube you have already added to your library.`;
export const AUTOMATION_LIBRARY_MESSAGE = `Make edits or changes to automated messages you have already added to your library.`;



export const MEDIA_LIBRARY_MESSAGE = ``;

export const WORKOUT_ADDED_MESSAGE = `Your workout has been added to your library. Feel free to make any edits or changes in this section. Please visit the Assign page to assign this workout to your clients, fans, followers, or partners.`;
export const PROGRAM_ADDED_MESSAGE = `Your program has been added to your library.  Feel free to make any edits or changes in this section. Please visit the Assign page to assign this program to your clients, fans, or followers`;
export const BLOCK_ADDED_MESSAGE = `Your block has been added to your library.  Feel free to make any edits or changes in this section. `;

export const LEFT_BAR_LINKS = [
  { text: 'Build', route: CONSTANTS_STATIC.BUILD_WORKOUT, hideMobile: true, icon: CONSTANTS_STATIC.LAYER_ICON },
  { text: 'Assign', route: '/assign/clients', hideMobile: false, icon: CONSTANTS_STATIC.CLIPBOARD_ICON },
 
  { text: 'Library', route: CONSTANTS_STATIC.LIB_WORKOUT, hideMobile: false, icon: CONSTANTS_STATIC.FOLDER_ICON },
  { text: 'Chat', route: '/chat', hideMobile: false, icon: CONSTANTS_STATIC.CLIPBOARD_ICON, break: true },
  { text: 'Past Assignments', route: '/assignments/workout', hideMobile: false, icon: 'clock', break: true },

  { text: 'Share', route: '/share', hideMobile: false, icon: 'share-alt' },
  { text: 'Help', route: '/help', hideMobile: false, icon: 'life-ring' }
]

export const FEATURED_LEFT_BAR_LINKS = [
  { text: 'Build', route: CONSTANTS_STATIC.BUILD_WORKOUT, hideMobile: true, icon: CONSTANTS_STATIC.LAYER_ICON },
  { text: 'Assign', route: '/assign/featured-brand', hideMobile: false, icon: CONSTANTS_STATIC.CLIPBOARD_ICON },
  { text: 'Library', route: CONSTANTS_STATIC.LIB_WORKOUT, hideMobile: false, icon: CONSTANTS_STATIC.FOLDER_ICON, break: true },
  { text: 'Chat', route: '/chat', hideMobile: false, icon: CONSTANTS_STATIC.CLIPBOARD_ICON, break: true },
  { text: 'Past Assignments', route: '/assignments/workout', hideMobile: false, icon: 'clock', break: true },

  { text: 'Social', route: '/social/posts', hideMobile: false, icon: faUsers },
  { text: 'Share', route: '/share', hideMobile: false, icon: 'share-alt' },
  { text: 'Help', route: '/help', hideMobile: false, icon: 'life-ring' }
]

export const COROPRATE_LEFT_BAR_LINKS = [
  { text: 'Brands', route: '/manageBrands/add', hideMobile: false, icon: faBuilding },
  { text: 'NCEP Trainers', route: '/manageNCEPTrainers/listing', hideMobile: false, icon: faUsers },
  { text: 'Trainers', route: '/manageTrainers/listing', hideMobile: false, icon: faUserAlt },
  { text: 'NCEP Stats', route: '/stats', hideMobile: false, icon: faAtom },
  { text: 'Push Notifications', route: '/managePushNotifications/add', hideMobile: false, icon: CONSTANTS_STATIC.PUSH_ICON },
  { text: 'Build', route: CONSTANTS_STATIC.BUILD_WORKOUT, hideMobile: true, icon: CONSTANTS_STATIC.LAYER_ICON },
  { text: 'Library', route: CONSTANTS_STATIC.LIB_WORKOUT, hideMobile: false, icon: CONSTANTS_STATIC.FOLDER_ICON },
  { text: 'Help', route: '/help', hideMobile: false, icon: 'life-ring' }
]

export const BUILD_LINKS = [
  { text: 'Workouts', route: CONSTANTS_STATIC.BUILD_WORKOUT, hideMobile: true },
  { text: 'Programs', route: '/build/program', hideMobile: true },
  { text: 'Blocks', route: '/build/block', hideMobile: true },
  { text: 'Exercises', route: '/build/exercise', hideMobile: true },
  { text: 'Automated Messages', route: '/build/automationMessages', hideMobile: true },
]

export const BRAND_BUILD_LINKS = [
  { text: 'Workouts', route: CONSTANTS_STATIC.BUILD_WORKOUT, hideMobile: true },
  { text: 'Programs', route: '/build/program', hideMobile: true },
  { text: 'Blocks', route: '/build/block', hideMobile: true },
  { text: 'Exercises', route: '/build/exercise', hideMobile: true },
  { text: 'Automated Messages', route: '/build/automationMessages', hideMobile: true },
  { text: 'YouTube', route: '/build/instruction', hideMobile: true }
]


export const ASSIGN_LINKS = [
  { text: 'Clients', route: '/assign/clients' },
  { text: 'Coach Channel', route: '/assign/partners' }
]

export const MANAGE_COMMUNITY_LINKS = [
  { text: 'Topics', route: '/community/topics' },
  { text: 'Photos', route: '/community/photos' }
]

export const MANAGE_BRAND_COMMUNITY_LINKS = [
  { text: 'Posts', route: '/social/posts' }
]

export const ASSIGN_CLIENTS_MESSAGE = [
  'Assign workouts and/or programs to your clients, friends, teams, or groups of people.',
  'Your clients must enroll in Fitbanx to recieve workouts and programs assigned to them.',
  '(The email address for your client must match the client\'s login email address for Fitbanx)'
].join(' ');

export const ASSIGN_MOBILE_CLIENTS_MESSAGE = [
  "Add clients and input metrics for the Functional Strength Screen so you can track your client's strength progress.",
  "(The email address for your client must match the client's login email address for FITBANX.)"
].join(' ');

export const ASSIGN_FEATURED_BRAND_MESSAGE = `Assign workouts and/or programs to your featured brand page.`

export const LIBRARY_LINKS = [
  { text: 'Workouts', route: CONSTANTS_STATIC.LIB_WORKOUT },
  { text: 'Programs', route: '/library/programs' },
  { text: 'Blocks', route: '/library/blocks' },
  { text: 'Exercises', route: '/library/exercises' },
  { text: 'Automated Messages', route: '/library/automationMessages' },
  { text: 'Cover Photo/Video', route: '/library/media' }
]

export const BRAND_LIBRARY_LINKS = [
  { text: 'Workouts', route: CONSTANTS_STATIC.LIB_WORKOUT },
  { text: 'Programs', route: '/library/programs' },
  { text: 'Blocks', route: '/library/blocks' },
  { text: 'Exercises', route: '/library/exercises' },
  { text: 'YouTube', route: '/library/instructions' },
  { text: 'Automated Messages', route: '/library/automationMessages' },
  { text: 'Cover Photo/Video', route: '/library/media' }
]

export const SETTINGS_LINKS = [
  { text: 'Edit Profile', route: '/settings/edit-profile' },
  { text: 'Preferences', route: '/settings/preferences' },
  { text: 'Plan & Billing', route: '/settings/billing' },
  { text: 'Statements', route: '/settings/statements' },
]

export const BRAND_SETTINGS_LINKS = [
  { text: 'Edit Profile', route: '/settings/edit-profile' },
  { text: 'Preferences', route: '/settings/preferences' },
  { text: 'Plan & Billing', route: '/settings/billing' },
  { text: 'Statements', route: '/settings/statements' }
]

export const CORPORATE_SETTINGS_LINKS = [
  { text: 'Preferences', route: '/settings/preferences' },
]

export const MANAGE_BRAND_LINKS = [
  { text: 'Add Brand', route: '/manageBrands/add' },
  { text: 'Change Order', route: '/manageBrands/listing' },
  { text: 'Update/Delete', route: '/manageBrands/edit' }
]

export const MANAGE_TRAINER_LINKS = [
  { text: 'Trainer Listing', route: '/manageTrainers/listing' },
  { text: 'Update/Delete', route: '/manageTrainers/edit' }
]

export const MANAGE_NCEP_TRAINER_LINKS = [
  { text: 'Trainer Listing', route: '/manageNCEPTrainers/listing' },
  { text: 'Update/Delete', route: '/manageNCEPTrainers/edit' }
]


export const MANAGE_PUSH_NOTIFICATION_LINKS = [
  { text: 'Push Notifications', route: '/managePushNotification/add' }
]

export const ASSIGNMENT_LINKS = [
  { text: 'Workout', route: '/assignments/workout' },
  { text: 'Programs', route: '/assignments/programs' },
  { text: 'Automated Messages', route: '/assignments/automations' }
]

export const DOWNLOAD_LINKS = [
  { text: 'Workout', route: '/download/workout' },
  { text: 'Programs', route: '/download/programs' }
]

export const ACCOUNTS_LINKS = [
  { text: 'My Partners', route: '/partners' },
  { text: 'My Payments', route: '/payments' },
  { text: 'Assignment History', route: '/assignments' },
  { text: 'Manage Categories', route: '/manage-categories', admin: true },
  { text: "Sign Out", route: '/signin' }
];

export const STATIC_TOP_PAGES_LINK = [
  { text: 'Who’s it for?', route: '/whosItFor' },
  { text: 'Featured brands', route: '/featureBrands' },
  { text: 'Pricing', route: '/pricing' },
]

export const STATIC_BOTTOM_PAGES_LINK = [
  { text: 'Contact Us', route: '/contactUs' },
  { text: 'Terms of use', route: '/terms' },
  { text: 'Privacy Policy', route: '/privacyPolicy' }
]

export const PRICING_OPTIONS = [
  { type: '0', text: 'Free' }, 
];

export const DASHBOARD_NAV = [
  {
    hideMobile: true,
    name: 'Build',
    links: BUILD_LINKS,
    icon: ''
  },
  {
    name: 'Assign',
    links: ASSIGN_LINKS,
    icon: ''
  },
  {
    name: 'Library',
    links: LIBRARY_LINKS,
    icon: ''
  },
  {
    name: 'My Account',
    links: ACCOUNTS_LINKS,
    icon: ''
  }
]

export const DESKTOP_MIN_WIDTH = 875;

export const DIFFICULTY_LEVELS = [
  { level: 1, text: 'Beginner' },
  { level: 2, text: 'Intermediate' },
  { level: 3, text: 'Advanced' }
]

export const HELP_LINKS = [
  { name: 'general', text: 'General Overview?' },
  { name: 'money', text: 'How to make money with Fitbanx?' },
  { name: 'buildWorkout', text: 'How to build workouts?' },
  { name: 'buildBlocks', text: 'How to build blocks?' },
  { name: 'buildPrograms', text: 'How to build programs?' },
  { name: 'assign', text: 'How to assign workouts and programs?' },
  { name: 'partners', text: 'All about partners?' },
  { name: 'changes', text: 'How to make changes to workouts, programs, ect.?' }
]

export const VALIDATION_MESSAGES = {
  WORKOUT: {
    name: 'Almost done...\n\nPlease go to Step 1 and give your workout a name.  Don’t forget to click save when done.',
    price: [
      'You forgot to list a price...\n\nPlease go to Step 1 and give your workout a price.',
      'If you want the workout to be free, don’t worry....just select free. Don’t forget to click save when done.'
    ].join(' '),
    level: 'One more thing...\n\nPlease go to Step 1 and select the level of difficulty for this workout so people know what to expect.  Don’t forget to click save when done.',
    categoryId: 'Whoops...you forgot to categorize your workout.\n\nPlease go to Step 1 and select a category for this workout.  Don’t forget to click save when done.'
  },
  PROGRAM: {
    name: 'Almost done...\n\nPlease go to Step 1 and give your program a name.  Don’t forget to click save when done.',
    price: [
      'You forgot to list a price...\n\nPlease go to Step 1 and give your program a price.',
      'If you want the program to be free, don’t worry....just select free. Don’t forget to click save when done. '
    ].join(''),
    level: 'One more thing...\n\nPlease go to Step 1 and select the level of difficulty for this program so people know what to expect.  Don’t forget to click save when done.',
    categoryId: 'Whoops...you forgot to categorize your workout.\n\nPlease go to Step 1 and select a category for this program.  Don’t forget to click save when done.'
  },
  TOPIC: {
    title: 'Title is required.',
    description: 'Description is required.'
  },
  IMAGE_LIMIT_EXCEEDS: size => 'Image is too large. The image you are trying to upload has a size of ' +
    `${(size / 1000000).toFixed(2)} MB. The limit for an image upload is ${IMAGE_SIZE_LIMIT_BYTES / 1000000} MB.` +
    ' Please upload another image.',
  VIDEO_LIMIT_EXCEEDS: size => 'Video is too large. The video you are trying to upload has a size of ' +
    `${(size / 1000000).toFixed(2)} MB. The limit for a video upload is ${VIDEO_SIZE_LIMIT_BYTES / 1000000} MB.` +
    ' Please upload another video.',
  TOPIC_VIDEO_LIMIT_EXCEEDS: size => 'Video is too large. The video you are trying to upload has a size of ' +
  `${(size / 1000000).toFixed(2)} MB. The limit for a video upload is ${TOPIC_VIDEO_SIZE_LIMIT_BYTES / 1000000} MB.` +
  ' Please upload another video.'
}



// WEBPACK FOOTER //
// ./src/static-content.js